// extracted by mini-css-extract-plugin
export default {"itemIcon":"styles_itemIcon__gyhYF","fileItem":"styles_fileItem__bS3wW","linkStyle":"styles_linkStyle__oygqr","pathBreadcrumb":"styles_pathBreadcrumb__EHOxs"};